var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxl:facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.897 21.2081V13.0121H16.662L17.073 9.80311H13.897V7.75911C13.897 6.83311 14.155 6.19911 15.484 6.19911H17.168V3.33811C16.3487 3.2503 15.5251 3.2079 14.701 3.21111C12.257 3.21111 10.579 4.70311 10.579 7.44211V9.79711H7.83203V13.0061H10.585V21.2081H13.897Z",
    fill: "#12110B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbfill);
export default __webpack_public_path__ + "static/media/fbfill.f1439177ed9882099057aae8245dd0d2.svg";
export { ForwardRef as ReactComponent };